<template>
  <zm-popover trigger="manual" name="participant" v-model="popVisible" popper-class="opc-participants-diff">
    <p class="desc-text" v-if="isLargeMeeting">{{ $t('billing.planform.large_meeting.capacity_intro') }}</p>

    <div class="diff-content large-meeting" @mouseenter="popContentHover = true" @mouseleave="handleMouseLeave"
         v-if="isLargeMeeting" @keydown.tab.prevent="handleTabKeydown">
      <table class="diff-table">
        <tr>
          <td class="capacity-label"></td>
          <td class="capacity-label">{{ $t('billing.participants') }}</td>
          <td class="capacity-label">{{ $t('billing.planform.introduction.participant.panelists') }}</td>
        </tr>
        <tr>
          <td class="capacity-detail detail-name">
            <p class="plan-category">{{ $t('billing.planform.title.zoom_one') }}</p>
          </td>
          <td class="capacity-detail">{{ $t('billing.planform.up_to', [Number(1000).toLocaleString()]) }}</td>
          <td class="capacity-detail grey">{{ $t('billing.common.n_a') }}</td>
        </tr>
        <tr>
          <td class="capacity-detail detail-name">
            <p class="plan-category">{{ $t('billing.webinar.brief_title') }}</p>
          </td>
          <td class="capacity-detail grey">{{ $t('billing.common.n_a') }}</td>
          <td class="capacity-detail">{{ $t('billing.planform.up_to', [Number(1000).toLocaleString()]) }}</td>
        </tr>
      </table>
    </div>

    <div class="diff-content" @mouseenter="popContentHover = true" @mouseleave="handleMouseLeave" v-else @keydown.tab.prevent="handleTabKeydown">
      <table class="diff-table">
        <tr>
          <td class="capacity-label"></td>
          <td class="capacity-label">{{ participants.share_screen }}</td>
          <td class="capacity-label">{{ participants.audio }}</td>
          <td class="capacity-label">{{ participants.video }}</td>
        </tr>
        <tr>
          <td class="capacity-detail detail-name">
            <p class="capacity-title">{{ participants.panelists }}</p>
            <p>{{ participants.panelist_desc }}</p>
          </td>
          <td class="capacity-detail"><i class="zm-icon-checked" aria-label="support"/></td>
          <td class="capacity-detail"><i class="zm-icon-checked" aria-label="support"/></td>
          <td class="capacity-detail"><i class="zm-icon-checked" aria-label="support"/></td>
        </tr>
        <tr>
          <td class="capacity-detail detail-name">
            <p class="capacity-title">{{ participants.attendees }}</p>
            <p>{{ participants.attendees_desc }}</p>
          </td>
          <td class="capacity-detail"><i class="zm-icon-close" aria-label="not support"/>
            <p class="detail-desc">
              <!-- Set opacity: 0; the purpose is to align the style in the mobile scene -->
              <span style='opacity: 0;'>{{ participants.listen_only }}</span>
            </p>
          </td>
          <td class="capacity-detail"><i class="zm-icon-close" aria-label="not support"/>
            <p class="detail-desc">{{ participants.listen_only }}</p>
          </td>
          <td class="capacity-detail"><i class="zm-icon-close" aria-label="not support"/>
            <p class="detail-desc">{{ participants.view_only }}</p>
          </td>
        </tr>
      </table>
      <ul class="ps-list" tabindex="0">
        <li v-html="participants.remark_1"></li>
        <li>{{ participants.remark_2 }}</li>
      </ul>
    </div>

    <i
      slot="reference"
      class="zm-icon-info-outline"
      tabindex="0"
      role="button"
      :aria-label="`Learn More about ${trackingPlanKey} Attendee Plans`"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      @keydown.enter="popVisible = true"
    />
  </zm-popover>
</template>
<script>
import {initDirectChange} from '@/plans/LARGE_MEETING/helper/axUtils';
import { isEventSaasOrEventSassCore, planTypes, trackingPlanTypes } from '@/common/constants';
import { get } from 'lodash';
import { capitalizeFirstLetter } from '@/common/utils';

export default {
  name: 'ParticipantsDiffPopover',
  props: {
    type: String,
  },
  data() {
    return {
      participants: {},
      popVisible: false,
      popContentHover: false,
    };
  },
  computed: {
    isLargeMeeting() {
      return this.type === planTypes.LARGE_MEETING;
    },
    trackingPlanKey () {
      return get(trackingPlanTypes, get(planTypes, this.type), "");
    },
    capacityUnitI18nKey() {
      return isEventSaasOrEventSassCore(this.type) ? capitalizeFirstLetter(this.$t('billing.attendees')) : this.$t('billing.participants');
    },
    remark1() {
      return isEventSaasOrEventSassCore(this.type) ? this.$t('billing.attendees_remark_1') : this.$t('billing.planform.introduction.participant.remark_1');
    },
    remark2() {
      return isEventSaasOrEventSassCore(this.type) ? this.$t('billing.attendees_remark_2') : this.$t('billing.planform.introduction.participant.remark_2');
    }
  },
  methods: {
    initParticipantsVal() {
      this.participants = {
        share_screen: this.$t('billing.planform.introduction.participant.share_screen'),
        audio: this.$t('billing.planform.introduction.participant.audio'),
        video: this.$t('billing.planform.introduction.participant.video'),
        panelists: this.$t('billing.planform.introduction.participant.panelists'),
        panelist_desc: this.$t('billing.planform.introduction.participant.panelist_desc'),
        attendees: this.capacityUnitI18nKey,
        attendees_desc: this.$t('billing.planform.introduction.participant.attendees_desc'),
        listen_only: this.$t('billing.planform.introduction.participant.listen_only'),
        view_only: this.$t('billing.planform.introduction.participant.view_only'),
        remark_1: this.remark1,
        remark_2: this.remark2
      }
    },
    handleMouseLeave(e) {
      e.preventDefault();
      let _this = this
      const {className} = e.target
      if (className.indexOf('diff-content') !== -1) {
        _this.popContentHover = false
      }
      setTimeout(() => {
        _this.popVisible = _this.popContentHover ? true : false
      }, 200)
    },
    handleTabKeydown() {
      this.popVisible = false
    },
    handleMouseEnter(e) {
      e.target.focus();
      this.popVisible = true;
    }
  },
  mounted() {
    this.initParticipantsVal()
    const table = this.$el.querySelector('.diff-table') || []
    initDirectChange(table)
  },
  watch: {
    popVisible: {
      handler(val) {
        val && this.$tracking.addOnBuyInteraction(`${this.trackingPlanKey} options`, 'attendees - tooltip');
      },
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../../../styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';
@import '@/styles/scss-utils.scss';

@mixin focus-outline {
  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px #fff, 0 0 0 4px $focus-color;
  }
}

.zm-icon-info-outline {
  cursor: pointer;
  color: #0B5CFF;
  margin-left: 5px;
  @include focus-outline;
  @include darkBlue;
}

.opc-participants-diff {
  .desc-text {
    color: #747487;
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 4px;
    width: 320px;
    @include darkTextColor;
  }

  .diff-content {
    width: 500px;
    @include media(mobile,tablet){
      width: 90vw;
      max-width: 500px;
    }
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid rgba(82, 82, 128, 0.18);

    &:focus-visible {
      border: 2px solid #0e71eb;
    }

    &.large-meeting {
      width: fit-content;

      .diff-table {
        width: auto;

        .capacity-detail {
          width: 120px;

          &.detail-name {
            width: 100px;
          }

          &.grey {
            color: rgba(4, 4, 19, 0.56);
            @include darkTextColor2;
          }

          .plan-category {
            font-weight: bold;
            color: #222230;
            opacity: 1;
            text-align: center;
            @include darkTextColor;
          }
        }
      }
    }
  }

  .diff-table {
    width: 500px;
    @include media(mobile,tablet){
      width: 100%;
    }
    font-size: 14px;
    border-spacing: 0;
    border-radius: inherit;

    .capacity-label {
      padding: 8px;
      background: #F7F7FC;
      font-weight: bold;
      margin: 0;
      text-align: center;
      border-right: 1px solid rgba(82, 82, 128, 0.18);
      border-bottom: 1px solid rgba(82, 82, 128, 0.18);
      vertical-align: middle;
      @include darkTextColor;
      @include darkBGColorTransparent;

      &:last-child {
        border-right: 0;
      }

      &:focus-visible {
        border: 2px solid #0e71eb;
      }
    }

    .capacity-detail {
      width: 80px;
      @include media(mobile,tablet){
        width: auto;
      }
      text-align: center;
      border-right: 1px solid rgba(82, 82, 128, 0.18);
      border-bottom: 1px solid rgba(82, 82, 128, 0.18);
      vertical-align: middle;

      &.detail-name {
        text-align: left;
        padding: 8px 12px;
      }

      p {
        color: #040413;
        opacity: 0.56;
        margin: 0;
        @include darkTextColor;
      }

      .capacity-title {
        width: 180px;
        @include media(mobile,tablet){
          width: auto;
        }
        margin-bottom: 5px;
        font-weight: bold;
        color: #222230;
        @include darkTextColor;
        opacity: 1;
      }

      .zm-icon-checked {
        color: $focus-color;
        font-size: 30px;
      }

      .zm-icon-close {
        color: $warning-color;
        font-size: 22px;
      }

      .detail-desc {
        width: 80px;
        @include media(mobile,tablet){
          width: auto;
        }
        margin: auto;
        min-height: 24px;
        word-break: break-word;
      }

      &:focus-visible {
        border: 2px solid #0e71eb;
      }
    }
  }

  .ps-list {
    display: flex;
    margin: 0;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 106px;
    @include media(mobile,tablet){
      height: auto;
    }
    max-width: 500px;
    @include media(mobile,tablet){
      max-width: none;
    }
    color: #747487;
    background: #f7f7fc;
    list-style-type: none;
    padding: 8px;
    @include darkBGColorTransparent;
    @include darkTextColor2;

    li {
      &::before {
        content: '• ';
      }

      padding: 5px 8px;
    }

    &:focus-visible {
      border: 2px solid #0e71eb;
    }
  }
}
</style>
